export const API_ENDPOINT = process.env.REACT_APP_SERVICE_API || "";
export const POSTCODE_ENDPOINT = process.env.REACT_APP_BASE_API || "";
export const GENERIC_ERROR_MESSAGE =
  "Sorry an error occurred, if the problem persists please get in touch with support@digital.well.co.uk";
export const USER_API = process.env.REACT_APP_USER_API || "";
